import LoadingStrip from "@/components/ui/LoadinStrip";
import { VerifyToken } from "@/utils/verifyToken";
import { setUser } from "@/redux/feature/auth/authSlice";
import { useAppDispatch } from "@/redux/hooks/hooks";
import React, { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

const VerifyGoogleSignIn = () => {
  const [searchParams] = useSearchParams();

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(true);
  // const [hasToastShown, setHasToastShown] = useState(false);
  const hasToastShown = useRef(false);
  const [hasProcessed, setHasProcessed] = useState(false);

  const accessToken = searchParams.get("accessToken");
  useEffect(() => {
    if (!accessToken || hasProcessed) {
      if (!accessToken) {
        toast.error("Google Log In Failed");
      }
      setIsLoading(false);
      navigate("/auth/sign-in");
      return;
    }

    setHasProcessed(true);
    const timer = setTimeout(() => {
      try {
        const user = VerifyToken(accessToken as string);
        dispatch(setUser({ user: user, token: accessToken as string }));
        navigate("/dashboard");

        setIsLoading(false);
      } catch (error) {
        toast.error("Invalid Access Token");
        navigate("/auth/sign-in");
      } finally {
        setIsLoading(false);
      }
    }, 2000);

    return () => clearTimeout(timer);
  }, [accessToken]);
  return (
    
      <div className="h-screen flex justify-center items-center w-full">
        {isLoading ? (
          <div className="text-center w-[200px] space-y-2">
            <p className="text-[16px] font-medium animate-pulse pb-2">
              Verifying...
            </p>
            <LoadingStrip />
          </div>
        ) : (
          <p className="text-[16px] font-semibold">Done</p>
        )}
      </div>
  );
};

export default VerifyGoogleSignIn;
